import { map } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { IHelperPage } from 'v2/interfaces/helperPage';

/**
 * Service responsible for controlling `HelperPage` component.
 *
 * @class HelperPageService
 */
class HelperPageService {
  /**
   * @method loadHelperPage
   * @return {Observable} an array of `IHelperPage` with the enabled configs on spreadsheet
   * returned by the API
   */
  public loadHelperPage = (page: string) => {
    return apiService
      .get<IHelperPage[]>('https://orbita-spreadsheet.eduzz.com/hints/helps')
      .pipe(map((helpers) => helpers.filter((h) => h.enabled && h.label === page)));
  };
}

const HelperPageServiceFactory = new HelperPageService();
export const helperPagesFactory = HelperPageServiceFactory;
